class CustomBundles extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListeners();
    }

    addEventListeners() {
        document.addEventListener("DOMContentLoaded", () => {
            let CTAs = document.querySelectorAll(".custom-bundles__cta");

            if (CTAs) {
                CTAs.forEach(cta => {
                    cta.addEventListener("click", function () {
                        let ids = this.dataset.ids.split(",").map(id => parseInt(id.trim()));
                        let items = ids.map(id => ({ id, quantity: 1 })); // Adjust quantity if needed

                        fetch("/cart/add.js", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({ items })
                        })
                        .then(response => response.json())
                        .then(data => {
                            console.log("Products added:", data);
                            window.location.href = "/cart";
                        })
                        .catch(error => console.error("Error adding to cart:", error));
                    });
                });
            }

            this.initSlider();
            window.addEventListener("resize", this.initSlider);
        });
    }

    initSlider() {
        let slider = $(".custom-bundles__grid");

        if (window.innerWidth < 768) {
            if (!slider.hasClass("slick-initialized")) {
                slider.slick({
                    lazyLoad: 'ondemand',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: '<button class="custom-bundle__arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--fill-color)"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z"/></svg></button>',
                    prevArrow: '<button class="custom-bundle__arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--fill-color)"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg></button>',
                    infinite: false,
                });
            }
        } else {
            if (slider.hasClass("slick-initialized")) {
                slider.slick("unslick");
            }
        }
    }
}

customElements.define("custom-bundles", CustomBundles);
